import { useRef } from 'react'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import { useSliderThumb } from '@react-aria/slider'
import styles from './styles.module.scss'

export const Thumb = ({ state, trackRef, index }) => {
  const inputRef = useRef(null)
  const { inputProps } = useSliderThumb(
    {
      index,
      trackRef,
      inputRef,
    },
    state
  )

  return (
    <div
      className={styles.thumb}
      style={{ left: `${state.getThumbPercent(index) * 100}%` }}
    >
      <VisuallyHidden>
        <input ref={inputRef} {...inputProps} />
      </VisuallyHidden>
    </div>
  )
}
